import {
  faFacebook,
  faGithub,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMeta,
  faReddit,
  faTiktok,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/pro-light-svg-icons";

export const getPlatformIcon = (platform: string) => {
  switch (platform && platform.toLowerCase()) {
    case "facebook":
      return faFacebook;
      break;
    case "twitter":
      return faTwitter;
      break;
    case "instagram":
      return faInstagram;
      break;
    case "reddit":
      return faReddit;
      break;
    case "linkedin":
      return faLinkedin;
      break;
    case "github":
      return faGithub;
      break;
    case "tiktok":
      return faTiktok;
      break;
    case "google_ads":
      return faGoogle;
      break;
    case "google ads":
      return faGoogle;
      break;
    case "meta":
      return faMeta;
      break;
    case "search":
      return faMagnifyingGlass;
      break;
    case "youtube":
      return faYoutube;
      break;
    default:
      return null;
  }
};
